import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'maskPhone',
})
export class MaskPhonePipe implements PipeTransform {
	transform(phoneNumber: string, toggleFullPhoneNumber?: boolean): string {
		return toggleFullPhoneNumber ? phoneNumber : `${phoneNumber.slice(0, -4)}XXXX`;
	}
}
